import { capitalize, forEach, isNumber, toString } from 'lodash';

export const capitalizeString = string => (
  toString(string).split(' ').map(capitalize).join(' ')
);

export const CPFMask = (cpf = "") => {
  if (!cpf) return "";

  cpf = toString(cpf);
  cpf = cpf.replace(/\D/g, "");
  cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
  cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

  return cpf;
};

export const CNPJMask = CNPJ => {
  if (!CNPJ) return "";

  CNPJ = toString(CNPJ);
  CNPJ = CNPJ.replace(/\D/g, "");
  CNPJ = CNPJ.substr(0, 14);
  CNPJ = CNPJ.replace(/(\d{2})(\d)/, "$1.$2");
  CNPJ = CNPJ.replace(/(\d{3})(\d)/, "$1.$2");
  CNPJ = CNPJ.replace(/(\d{3})(\d)/, "$1/$2");
  CNPJ = CNPJ.replace(/(\d{4})(\d)/, "$1-$2");
  CNPJ = CNPJ.replace(/(\d{2})$/, "$1");

  return CNPJ;
};

// TODO: Write test
export const getFromAtob = params => {
  let results = [];

  forEach(params, param => {
    try {
      const result = atob(param);
      results.push(result);
    } catch (e) {
      results.push('');
    }
  });

  return results;
};

export const localeString = value => {
  value = value || "";
  return value.toLocaleString("pt-BR");
};

export const numberToBRL = amount => {
  if (!isNumber(amount)) return '';
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(amount);
};

export const removeNonDigits = value => {
  value = toString(value);
  if (value.length === 0) return '';
  return value.replace(/\D/g, '');
};

export const scrollToElement = elem => (
  elem && elem.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "start",
  })
);

export const telefoneMask = telefone => {
  telefone = removeNonDigits(telefone);
  if (!telefone) return "";

  const primeiraParte = `(${telefone.substr(0,2)}) ${telefone.substr(2,5)}`;
  const segundaParte = `-${telefone.substr(7,4)}`;

  switch (telefone.length) {
    case 1:
      return `(${telefone}`;
    case 2:
      return `(${telefone.substr(0,2)}`;
    default:
      return telefone.length > 7 ? `${primeiraParte}${segundaParte}` : primeiraParte;
  }
};

export const zipCodeMask = zipCode => {
  zipCode = removeNonDigits(zipCode);
  return `${zipCode.substr(0,2)}.${zipCode.substr(2,3)}-${zipCode.substr(5,3)}`;
};

export const COLORS = [
  '#FF6384',
  '#FF9F40',
  '#4DC9F6',
  '#ACC236',
  '#58595B',
  '#537BC4',
  '#00A950',
  '#166A8F',
  '#8549BA',
];



// WEBPACK FOOTER //
// ./src/services/utils.js